/* Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { Component, Input } from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { NvDisableTooltipDirective } from '../../directives/nv-disable-tooltip.directive';
import { NvHigListMetadata } from '../../models/hig-list-metadata.types';

@Component({
    selector: 'nv-hig-list-metadata',
    templateUrl: './nv-hig-list-metadata.component.html',
    styleUrls: ['./nv-hig-list-metadata.component.scss'],
    imports: [ExtendedModule, MatIconModule, MatTooltipModule, NvDisableTooltipDirective]
})
export class NvHigListMetadataComponent {
    private _metadata: NvHigListMetadata = {
        showMetadata: false
    };

    @Input()
    set metadata(value: NvHigListMetadata) {
        this._metadata = value;
        this.dotVisibility = this.computeDotVisibility();
    }
    get metadata(): NvHigListMetadata {
        return this._metadata;
    }

    // Public property that will be used directly in template
    public dotVisibility: boolean[] = [];

    private computeDotVisibility(): boolean[] {
        const dotListForMetadata: boolean[] = [];
        this._metadata?.itemList?.forEach((item, index) => {
            if (
                index !== this._metadata.itemList.length - 1 &&
                item?.icon &&
                item?.text &&
                this._metadata.itemList[index + 1]?.icon &&
                this._metadata.itemList[index + 1]?.text
            ) {
                dotListForMetadata.push(true);
            } else {
                dotListForMetadata.push(false);
            }
        });
        return dotListForMetadata;
    }
}
